var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4749 5.02513C15.8417 6.39197 15.8417 8.60804 14.4749 9.97488C13.108 11.3417 10.892 11.3417 9.52513 9.97488C8.15829 8.60804 8.15829 6.39197 9.52513 5.02513C10.892 3.65829 13.108 3.65829 14.4749 5.02513",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 18.9998V19.9998C4 20.5518 4.448 20.9998 5 20.9998H19C19.552 20.9998 20 20.5518 20 19.9998V18.9998C20 15.9738 16.048 14.0078 12 14.0078C7.952 14.0078 4 15.9738 4 18.9998Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestAccess);
export default __webpack_public_path__ + "static/media/guestAccess.65c8201a.svg";
export { ForwardRef as ReactComponent };